import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import ProductGrid from '../components/ProductGrid';

const SearchResults = ({ products }) => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  
  const [results, setResults] = useState([]);

  // 搜索商品
  useEffect(() => {
    if (query && products) {
      const lowercasedQuery = query.toLowerCase();
      const searchResults = products.filter(product =>
        product.name.toLowerCase().includes(lowercasedQuery) ||
        product.description.toLowerCase().includes(lowercasedQuery) ||
        product.crystalType.toLowerCase().includes(lowercasedQuery)
      );
      setResults(searchResults);
    } else {
      setResults([]);
    }
  }, [query, products]);

  return (
    <div className="container mx-auto px-4 py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">搜索结果</h1>
        {query && (
          <p className="text-gray-600 mt-2">
            关键词 "{query}" 的搜索结果，共找到 {results.length} 个商品
          </p>
        )}
      </div>
      
      {results.length > 0 ? (
        <ProductGrid products={results} />
      ) : (
        <div className="text-center py-10 bg-white bg-opacity-90 rounded-lg shadow-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 mx-auto text-gray-300 mb-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <p className="text-gray-500 mb-4">
            {query
              ? `没有找到与 "${query}" 相关的商品`
              : '请输入搜索关键词'}
          </p>
          <Link
            to="/category"
            className="inline-block bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark transition-colors"
          >
            浏览所有商品
          </Link>
        </div>
      )}
    </div>
  );
};

export default SearchResults;